// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"GU-z","inlineTitle":"HU-z","sponsoredAdsWrapper":"IU-z","marketplaceRecosWrapper":"JU-z"};